/**
 * EDI footer UI logic
 *
 * Created by ipatrikeeva on 03/28/2018
 */

/*jshint strict:false */
/*global Backbone, $, App */

/**
 * Hide EDI footer
 */
function hideFooter() {
    var parentId = App.globalState.footerParentId;
    $('#' + parentId).hide();
}

/**
 * Initialize EDI footer.
 */
function setFooter() {
    var parentId = App.globalState.footerParentId,
        helpDeskEmail = App.globalState.helpDeskEmail;

    // Listen for DOM mutation events and trigger additional header styling when element was inserted
    var observer = getMutationObserver('footer', null);
    var config = {
        attributes: false,
        childList: true,
        characterData: false
    };
    var target = document.getElementById(App.globalState.footerParentId);
    observer.observe(target, config);

    // Detach existing footer element if it exists from a different page
    var footer = $('.footer');
    footer.remove();

    // Attach EDI footer from shared UI components
    // Shared JavaScript file is in /var/www/static/js/edi-styles.js
    if (!App.globalState.isDev) {
        // Check if footer already exists
        ediFooter( parentId, helpDeskEmail, App.globalState.name, App.globalState.version );
    }

    $('#' + parentId).show();
}
